module.exports = __webpack_public_path__ + "img/icon_doctor.5199c55b.png";